
import { defineStore } from "pinia";
import router from "@/router";
import request from "@/utils/request";
import { Local } from '@/utils/storage'
import { getInvestorMechanismList, queryCategoryChild } from '@/api/index'
import { getVenueAreas } from "@/api/venue";
import { getAdminBindMec } from '@/api/operate'
export const useSystemStore = defineStore("system", {
    state: () => {
        return {
            admin_name: Local.get("managerInfo")?.name || '登录',
            current_mechanism: Local.get("current_mechanism") || {},
            mechanism_list: Local.get("mechanism_list") || [],
            categories_list: [],
            area_list: [],
            curOpenTableOrderId: ''
        }
    },
    actions: {
        loginTim() {
            
        },
        /**
        * 获取类目列表
        */
        getCategorys() {
            queryCategoryChild().then((res: ResultData) => {
                this.categories_list = res.data
            })
        },
        getVenueAreaList() {
            if (!Local.get("current_venue")) {
                return
            }
            getVenueAreas().then((res: ResultData) => {
                this.area_list = res.data
            })
        },


        /**
         * 切换机构
         * @param mec 机构信息
         */
        changeMechanism(mec: any) {
            if (mec.id) {
                this.current_mechanism = mec
                Local.set("current_mechanism", mec)
                router.go(0)
            }
        },
        /**
         * 获取当前角色的分店列表
         */
        getSubMechanismList() {
            const main_mechanism = Local.get("main_mechanism")
            if (Local.get("type") == "union") {
                getInvestorMechanismList().then((res: ResultData) => {
                    if (res.data.length > 0) {
                        let list = res.data
                        this.current_mechanism = list[0]
                        this.mechanism_list = list
                        Local.set("mechanism_list", list);
                    }
                    router.push("/");
                });
            }else if(Local.get("type") == "enroll"){
                getAdminBindMec().then((res: ResultData) => {
                    if (res.data.length > 0) {
                        let list = res.data
                        this.current_mechanism = list[0]
                        this.mechanism_list = list
                        Local.set("mechanism_list", list);
                    }
                });
            } else if (main_mechanism && main_mechanism.parent_id === 0) {
                request
                    .get("/user/mastermechanism/queryListPage", { status: 2, parent_id: main_mechanism.id })
                    .then((res: any) => {
                        let list = res.data;
                        if (list.length > 0) {
                            list.unshift(main_mechanism)
                            this.mechanism_list = list
                            Local.set("mechanism_list", list);
                        }
                    });
            } else {
                this.mechanism_list = [main_mechanism]
                Local.set("mechanism_list", this.mechanism_list);
            }
        }
    }
})